import React, { useEffect } from "react";
import "./App.css";

import { HashRouter, Routes, Route } from "react-router-dom";
import { GlobalProvider } from "./GlobalState/GlobalContext";
import { PermissionProvider } from "./GlobalState/PermissionContext";
import routeConstants from "./constants/routeConstants.json";
import Login from "./containers/Login";
import ForgotPassword from "./containers/ForgotPassword";
import Layout from "./components/Layout/Layout";
import RoleListPage from "./containers/RoleManagement/RolesList";
import AdminListPage from "./containers/AdminManagement/AdminList";
import NonAuthRouteProtection from "./containers/NonAuthRouteProtection";
import ProfileInfo from "./containers/ProfileManagement/ProfileInfoPage/";
import EditProfile from "./containers/ProfileManagement/EditProfile";
import ChangePassword from "./containers/ProfileManagement/ChangePassword/";
import AuthRouteProtection from "./containers/AuthRouteProtection";
import AddRoles from "./containers/RoleManagement/AddRoles";
import ViewRoleManagePage from "./containers/RoleManagement/ViewRole";
import EditRoles from "./containers/RoleManagement/EditRoles";
import AddAdminPage from "./containers/AdminManagement/AddAdmin";
import EditAdminPage from "./containers/AdminManagement/EditAdmin";
import ViewAdminManagePage from "./containers/AdminManagement/ViewAdmin";
import ResetPasswordPage from "./containers/Resetpassword";
import SetPasswordPage from "./containers/Setpassword";
import DashBoard from "./containers/DashBoard";
import ProtectedRoute from "./containers/ProtectedRoute/ProtectedRoute";
import BackNavigationHandler from "./containers/BackNavigationHandler";
import { ProductListPage } from "./containers/ProductManagement/ProductList";
import { EditProductPage } from "./containers/ProductManagement/EditProduct";
import { AddProductPage } from "./containers/ProductManagement/AddProduct";
import { ProductDetailsPage } from "./containers/ProductManagement/ProductDetails";
import DealerListPage from "./containers/DealerMangement/DealerList";
import AddDealerPage from "./containers/DealerMangement/AddDealer";
import EditDealerPage from "./containers/DealerMangement/EditDealer";
import DealerDetailsPage from "./containers/DealerMangement/DealerDetails";

const App = () => {
  const dealerFeatureid = "67b4165e2efc50c984271c80";
  const roleFeatureid = "66f50472b58f398ba8f04a8b";
  const adminFeatureid = "66f506fa5a192b6c70a82cd8";
  const productFeatureid = "67b416502efc50c984271c7c";
  return (
    <HashRouter>
      <BackNavigationHandler />

      <GlobalProvider>
        <Routes>
          <Route element={<NonAuthRouteProtection />}>
            <Route path={routeConstants.LOGIN} element={<Login />} />
            <Route
              path={routeConstants.FORGOT_PASSWORD}
              element={<ForgotPassword />}
            />
            <Route
              path={routeConstants.RESET_PASSWORD}
              element={<ResetPasswordPage />}
            />
            <Route
              path={routeConstants.SET_PASSWORD}
              element={<SetPasswordPage />}
            />
          </Route>
          <Route element={<PermissionProvider />}>
            <Route element={<AuthRouteProtection />}>
              <Route element={<Layout />}>
                <Route
                  path={routeConstants.ROLE_LIST}
                  element={
                    <ProtectedRoute
                      element={RoleListPage}
                      featureId={roleFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_ROLE}
                  element={
                    <ProtectedRoute
                      element={AddRoles}
                      featureId={roleFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_ROLE}
                  element={
                    <ProtectedRoute
                      element={EditRoles}
                      featureId={roleFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.VIEW_ROLE}
                  element={
                    <ProtectedRoute
                      element={ViewRoleManagePage}
                      featureId={roleFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.DASHBOARD}
                  element={<DashBoard />}
                />
                <Route
                  path={routeConstants.VIEW_PROFILE}
                  element={<ProfileInfo />}
                />
                <Route
                  path={routeConstants.EDIT_PROFILE}
                  element={<EditProfile />}
                />
                <Route
                  path={routeConstants.CHANGE_PASSWORD}
                  element={<ChangePassword />}
                />
                <Route
                  path={routeConstants.ADMIN_LIST}
                  element={
                    <ProtectedRoute
                      element={AdminListPage}
                      featureId={adminFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_ADMIN}
                  element={
                    <ProtectedRoute
                      element={AddAdminPage}
                      featureId={adminFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_ADMIN}
                  element={
                    <ProtectedRoute
                      element={EditAdminPage}
                      featureId={adminFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.VIEW_ADMIN}
                  element={
                    <ProtectedRoute
                      element={ViewAdminManagePage}
                      featureId={adminFeatureid}
                      action="view"
                    />
                  }
                />
                {/* dealer management */}
                <Route
                  path={routeConstants.LIST_DEALER}
                  element={
                    <ProtectedRoute
                      element={DealerListPage}
                      featureId={dealerFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_DEALER}
                  element={
                    <ProtectedRoute
                      element={AddDealerPage}
                      featureId={dealerFeatureid}
                      action="add"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_DEALER}
                  element={
                    <ProtectedRoute
                      element={EditDealerPage}
                      featureId={dealerFeatureid}
                      action="edit"
                    />
                  }
                />
                <Route
                  path={routeConstants.DEALER_DETAILS}
                  element={
                    <ProtectedRoute
                      element={DealerDetailsPage}
                      featureId={dealerFeatureid}
                      action="view"
                    />
                  }
                />

                {/* product management */}
                <Route
                  path={routeConstants.LIST_PRODUCTS}
                  element={
                    <ProtectedRoute
                      element={ProductListPage}
                      featureId={productFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.EDIT_PRODUCT}
                  element={
                    <ProtectedRoute
                      element={EditProductPage}
                      featureId={productFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.ADD_PRODUCT}
                  element={
                    <ProtectedRoute
                      element={AddProductPage}
                      featureId={productFeatureid}
                      action="view"
                    />
                  }
                />
                <Route
                  path={routeConstants.PRODUCT_DETAILS}
                  element={
                    <ProtectedRoute
                      element={ProductDetailsPage}
                      featureId={productFeatureid}
                      action="view"
                    />
                  }
                />
                <Route />
              </Route>
            </Route>
          </Route>
        </Routes>
      </GlobalProvider>
    </HashRouter>
  );
};

export default App;
